import Head from 'next/head'
import Image from 'next/image'
import { StaticImageData } from 'next/image'

import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import multipleCards from '@images/multiple-cards.png'
import personOnBenchWithPhone from '@images/person-on-bench-with-phone.png'
import personWithPhone from '@images/person-receiving-offers.png'
import phoneWithApproval from '@images/phone-with-approval.png'

import UnscoredCategoryPageButton from '../UnscoredCategoryPageButton'
import { applySections } from './lib/applySections'

const image: Record<number, { alt: string; src: StaticImageData }> = {
    0: {
        alt: 'Person receiving offers',
        src: personWithPhone,
    },

    1: {
        alt: 'multiple cards',
        src: multipleCards,
    },

    2: {
        alt: 'Phone with approval on the screen',
        src: phoneWithApproval,
    },

    3: {
        alt: 'Person on bench with a phone',
        src: personOnBenchWithPhone,
    },
}

const UnscoredCategoryPageApplySection = ({
    page,
    title,
}: {
    page: CreditCardProductCategory
    title: string
}) => {
    const applySectionsData = applySections[page]

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@type': 'HowTo',
                            name: title,
                            step: applySectionsData?.map(
                                ({ heading, text }, i) => ({
                                    '@type': 'HowToStep',
                                    name: heading,
                                    position: i + 1,
                                    text,
                                })
                            ),
                        }),
                    }}
                />
            </Head>

            <Box gridColumn="1/13" id="apply-for-credit-cards">
                <Box
                    display="grid"
                    gridTemplateColumns={[
                        '1fr',
                        'repeat(2, 1fr)',
                        'repeat(4, 1fr)',
                    ]}
                    gridGap="space30"
                    mb="space50"
                >
                    {applySectionsData?.map(({ heading, text }, i: number) => (
                        <Flex justifyContent="center" key={`${heading}-${i}`}>
                            <Stack space="space20" maxWidth="282px">
                                <Flex justifyContent="center">
                                    <Image
                                        alt={image[i].alt}
                                        src={image[i].src}
                                        quality={60}
                                        priority={false}
                                        placeholder="empty"
                                        sizes="96px"
                                        width={96}
                                        height={96}
                                    />
                                </Flex>

                                <Heading
                                    as="h6"
                                    variant="40"
                                    textAlign="center"
                                >
                                    {heading}
                                </Heading>

                                <Text variant="100" textAlign="center">
                                    {text}
                                </Text>
                            </Stack>
                        </Flex>
                    ))}
                </Box>

                <Flex justifyContent="center">
                    <UnscoredCategoryPageButton />
                </Flex>
            </Box>
        </>
    )
}

export default UnscoredCategoryPageApplySection
